<template>
  <modal-template size="small"
                  class="how-many-seats"
                  @close="$emit('closeHowManySeats')">
    <div class="container-selector-tickets">
      <button class="btn round minus transparent"
              @click="minusQuantity(quantity)">-</button>
      <span class="quantity">{{ quantity }}</span>
      <button class="btn round more transparent"
              @click="moreQuantity(quantity)">+</button>
    </div>
    <button :disabled="isDisabled"
            :class="{'topaz': !isDisabled, 'transparent': isDisabled}"
            class="btn mT20"
            @click="setNumberSeats()">{{ $t('chatTools.siguiente') }}</button>

  </modal-template>
</template>

<script>
import ModalTemplate from '@/components/modal-template/ModalTemplate.vue'

export default {
  components: {
    ModalTemplate
  },
  props: {
    maxSelectedObjects: {
      type: Number,
      default: 12
    }
  },
  data: () => ({
    quantity: 0
  }),
  computed: {
    isDisabled() {
      return !this.quantity > 0
    }
  },
  methods: {
    setNumberSeats() {
      this.$emit('setHowManySeats', this.quantity)
    },
    minusQuantity() {
      this.quantity = this.quantity === 0 ? 0 : this.quantity - 1
    },
    moreQuantity() {
      this.quantity =
        this.quantity === this.maxSelectedObjects
          ? this.maxSelectedObjects
          : this.quantity + 1
    }
  }
}
</script>

<style lang="scss">
#wegow-default-styles {
  .how-many-seats {
    display: flex;
    .container-selector-tickets {
      justify-content: center;
    }
  }
}
</style>
